module.exports = __webpack_public_path__ + "static/assets/fe766a28f67325171922e0902a7b99ac.svg";